(function () {
  if (!window.__pllpDelegated) {
    window.__pllpDelegated = true;
    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('[data-pllp-open]');
      if (!trigger) return;
      e.preventDefault();
      const el = document.getElementById(trigger.dataset.pllpTarget);
      if (el && typeof el.open === 'function') {
        el.open(parseInt(trigger.dataset.pllpIndex || '0', 10));
      }
    });
  }

  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    })[c]);

  class PlLookPopup extends HTMLElement {
    connectedCallback() {
      try {
        const data = this.querySelector('[data-pllp-data]');
        this.looks = data ? JSON.parse(data.textContent) : [];
      } catch (e) {
        this.looks = [];
      }
      this.shopLabel = this.dataset.shopLabel || 'Shop';
      this.index = 0;
      this.built = false;
      this.onKey = (e) => {
        if (!this.modal || this.modal.hidden) return;
        if (e.key === 'Escape') this.close();
        if (e.key === 'ArrowLeft') this.go(-1);
        if (e.key === 'ArrowRight') this.go(1);
      };
      document.addEventListener('keydown', this.onKey);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKey);
    }

    build() {
      if (this.built) return;
      const multi = this.looks.length > 1;
      const slides = this.looks.map((look, i) => this.slideHtml(look, i)).join('');
      this.modal = document.createElement('div');
      this.modal.className = 'pllp__modal';
      this.modal.hidden = true;
      this.modal.innerHTML =
        '<div class="pllp__overlay" data-pllp-close></div>' +
        '<button type="button" class="pllp__close" data-pllp-close aria-label="Close"><svg viewBox="0 0 18 18" aria-hidden="true"><g stroke="currentColor" fill="none" fill-rule="evenodd"><path d="M1 1l16 16M17 1L1 17"></path></g></svg></button>' +
        (multi
          ? '<button type="button" class="pllp__nav pllp__nav--prev" data-pllp-prev aria-label="Previous"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 4l-8 8 8 8" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="square"/></svg></button>' +
            '<button type="button" class="pllp__nav pllp__nav--next" data-pllp-next aria-label="Next"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4l8 8-8 8" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="square"/></svg></button>'
          : '') +
        slides;
      document.body.appendChild(this.modal);

      this.slides = Array.from(this.modal.querySelectorAll('[data-pllp-slide]'));
      this.modal.querySelectorAll('[data-pllp-close]').forEach((el) =>
        el.addEventListener('click', () => this.close())
      );
      const prev = this.modal.querySelector('[data-pllp-prev]');
      const next = this.modal.querySelector('[data-pllp-next]');
      if (prev) prev.addEventListener('click', () => this.go(-1));
      if (next) next.addEventListener('click', () => this.go(1));
      this.built = true;
    }

    slideHtml(look, i) {
      const mediaInner =
        look.type === 'video' && look.video
          ? '<video muted loop playsinline preload="none"' +
            (look.image ? ' poster="' + esc(look.image) + '"' : '') +
            '><source src="' + esc(look.video) + '" type="video/mp4"></video>'
          : look.image
          ? '<img src="' + esc(look.image) + '" alt="' + esc(look.author) + '" loading="lazy">'
          : '';

      const products = (look.products || [])
        .map(
          (p, n) =>
            '<div class="pllp__product">' +
            '<a href="' + esc(p.url) + '" class="pllp__product-media">' +
            (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
            '</a>' +
            '<div class="pllp__product-meta"><span class="pllp__product-index">' + (n + 1) + '</span><span>' + esc(p.price) + '</span></div>' +
            '<div class="pllp__product-title">' + esc(p.title) + '</div>' +
            '<a href="' + esc(p.url) + '" class="pllp__shop">' + esc(this.shopLabel) + '</a>' +
            '</div>'
        )
        .join('');

      const author =
        look.author || look.caption
          ? '<div class="pllp__author">' +
            (look.avatar ? '<span class="pllp__avatar"><img src="' + esc(look.avatar) + '" alt=""></span>' : '') +
            (look.author ? '<span>By ' + esc(look.author) + '</span>' : '') +
            '</div>' +
            (look.caption ? '<div class="pllp__caption">' + look.caption + '</div>' : '')
          : '';

      return (
        '<div class="pllp__box" data-pllp-slide="' + i + '"' + (i === 0 ? '' : ' hidden') + '>' +
        '<div class="pllp__media">' + mediaInner + '</div>' +
        '<div class="pllp__panel"><div class="pllp__products">' + products + '</div>' + author + '</div>' +
        '</div>'
      );
    }

    open(i) {
      this.build();
      if (!this.modal) return;
      this.modal.hidden = false;
      document.body.style.overflow = 'hidden';
      this.show(i || 0);
    }

    close() {
      if (!this.modal) return;
      this.modal.hidden = true;
      document.body.style.overflow = '';
      this.pauseAll();
    }

    go(dir) {
      const n = (this.index + dir + this.slides.length) % this.slides.length;
      this.show(n);
    }

    show(i) {
      this.index = i;
      this.pauseAll();
      this.slides.forEach((slide, n) => {
        const active = n === i;
        slide.hidden = !active;
        if (active) {
          const v = slide.querySelector('video');
          if (v) {
            try {
              v.currentTime = 0;
              v.play();
            } catch (e) {}
          }
          const panel = slide.querySelector('.pllp__panel');
          if (panel) panel.scrollTop = 0;
        }
      });
    }

    pauseAll() {
      if (!this.modal) return;
      this.modal.querySelectorAll('video').forEach((v) => {
        try {
          v.pause();
        } catch (e) {}
      });
    }
  }

  if (!customElements.get('pl-look-popup')) customElements.define('pl-look-popup', PlLookPopup);
})();
